import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import Popover from '@material-ui/core/Popover';
import Fade from '@material-ui/core/Fade';
import SvgIcon from '@material-ui/core/SvgIcon';
import FileAttach from '../../../components/FileAttach/index';
import Video from '../../../assets/images/video-cam';
import trashIcon from '../../../assets/images/trash-card';
import PaperClip from '../../../assets/images/paperclip';
import Link from '../../../assets/images/link';
import {isChrome, isIpad} from '../../../utils/screenUtility';
import BaseButtonWithIcon from '../../../components/button/BaseButtonWithIcon';
import {withTooltip} from '../../../components/toolTip/withTooltip';
import VideoPlayer from '../../../components/videoPlayer';
import chevron from '../../../assets/images/chevron';
import mainStore from '../../main/store';

@injectIntl
@withTooltip
@observer
class LessonInfoVideo extends Component {
    @observable activeIndex = 0;

    componentDidUpdate(prevProps) {
        if (prevProps.isSaveProcessing !== this.props.isSaveProcessing) {
            if (!this.props.isSaveProcessing) {
                this.changeActiveIndex(this.props.videoList.length - 1);
            }
        }
    }

    @action changeActiveIndex = (val) => {
        this.activeIndex = val;
    };

    prevSlide = () => {
        const index = this.activeIndex > 0 ? this.activeIndex - 1 : this.props.videoList.length - 1;
        this.changeActiveIndex(index);
    };

    nextSlide = () => {
        const index = this.activeIndex < this.props.videoList.length - 1 ? this.activeIndex + 1 : 0;
        this.changeActiveIndex(index);
    };

    handleRemoveVideo = index => action(() => {
        this.props.onRemove(index);
        if (this.activeIndex === this.props.videoList.length - 1) {
            this.activeIndex = this.props.videoList.length - 2;
        }
    });

    handleFileChange = (files) => {
        const {onSave, onDismissTooltip} = this.props;
        onSave(files[0]);
        onDismissTooltip();
    };

    handleRecordOpen = () => {
        const {onRecordOpen, onDismissTooltip} = this.props;
        onRecordOpen();
        onDismissTooltip();
    };

    openLinkForm = () => {
        const {onDismissTooltip, onVideoLinkOpen} = this.props;
        onVideoLinkOpen();
        onDismissTooltip();
    };

    setRef = (node) => {
        this.button = node;
    };

    render() {
        const {videoList, openVideoPreview, disabled, onOpenTooltip,
            isTooltipOpen, onDismissTooltip, isSaveProcessing, isEditable, intl: {formatMessage: translate}} = this.props;

        return (
            <div className="lesson-info-video">
                <div className="video-message-top">
                    <div className="lesson-label">
                        <FormattedMessage id={'createLesson.message'}/>
                    </div>
                    {videoList.length ?
                        <div className="video-message-controls">
                            <button className="v-arrow prev" onClick={this.prevSlide}>
                                <SvgIcon viewBox="0 0 24 24">{chevron}</SvgIcon>
                            </button>
                            <div className="v-center">{this.activeIndex + 1} / {videoList.length}</div>
                            <button className="v-arrow next" onClick={this.nextSlide}>
                                <SvgIcon viewBox="0 0 24 24">{chevron}</SvgIcon>
                            </button>
                        </div>
                        :
                        <div className="video-message-controls disabled">
                            <div className="v-arrow prev">
                                <SvgIcon viewBox="0 0 24 24">{chevron}</SvgIcon>
                            </div>
                            <div className="v-center">0 / 0</div>
                            <div className="v-arrow next">
                                <SvgIcon viewBox="0 0 24 24">{chevron}</SvgIcon>
                            </div>
                        </div>
                    }
                </div>
                <div className={`lesson-video ${isSaveProcessing ? 'with-progress' : ''}`}>
                    <div className="lesson-video-box">
                        {isSaveProcessing && <div className="circular-loader" />}
                        {!videoList.length ?
                            <div className="video-placeholder-box">
                                <div className="video-placeholder-top"/>
                                <div className="video-placeholder-body"/>
                            </div>
                            :
                            videoList.map((video, index) => (
                                (index === this.activeIndex) ?
                                    <Fragment key={video.src}>
                                        {!mainStore.isHomeMode && <div className="lesson-video-preview-overlay" onClick={openVideoPreview(video.src)}/>}
                                        <VideoPlayer
                                            thumbnail={true}
                                            playing={false}
                                            controls={true}
                                            url={video.src}
                                            light={!mainStore.isHomeMode && !video.fromS3}
                                            title={!video.fromS3 ? video.src : <FormattedMessage id="createLesson.videoRecording"/>}
                                        />
                                        {isEditable &&
                                            <SvgIcon
                                                className="remove-video-btn"
                                                viewBox="0 0 16 16"
                                                onClick={this.handleRemoveVideo(this.activeIndex)}>
                                                {trashIcon}
                                            </SvgIcon>
                                        }
                                    </Fragment>
                                    : null
                            ))
                        }
                    </div>
                    {isEditable && <div className="lesson-info-actions">
                        <BaseButtonWithIcon
                            buttonRef={this.setRef}
                            icon={Video}
                            viewBox="0 0 20 20"
                            className="lesson-video-btn"
                            label={translate({id: 'createLesson.addVideo'})}
                            onClick={onOpenTooltip} />
                        <Popover
                            className="video-popover"
                            classes={{paper: 'video-popover-area'}}
                            anchorEl={this.button}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            TransitionComponent={Fade}
                            open={isTooltipOpen}
                            onClose={onDismissTooltip}>
                            <div className="video-popover-content">
                                {!isIpad() && isChrome() && <BaseButtonWithIcon
                                    icon={Video}
                                    disableTouchRipple={true}
                                    viewBox="0 0 20 20"
                                    className="video-popover-btn"
                                    label={translate({id: 'createLesson.recordVideo'})}
                                    onClick={this.handleRecordOpen} />}
                                <FileAttach
                                    fileExtension="video/*"
                                    style={{display: 'flex', width: 'auto'}}
                                    className={disabled ? 'disabled' : ''}
                                    onChange={this.handleFileChange}
                                    onError={() => {}}>
                                    <BaseButtonWithIcon
                                        disableTouchRipple={true}
                                        viewBox="0 0 36 36"
                                        className="video-popover-btn link"
                                        icon={PaperClip}
                                        label={translate({id: `createLesson.${isIpad() ? 'uploadOrRecord' : 'uploadVideo'}`})} />
                                </FileAttach>
                                <BaseButtonWithIcon
                                    icon={Link}
                                    disableTouchRipple={true}
                                    viewBox="0 0 36 36"
                                    className="video-popover-btn link"
                                    label={translate({id: 'createLesson.linkUrl'})}
                                    onClick={this.openLinkForm} />
                            </div>
                        </Popover>
                    </div>}
                </div>
            </div>
        );
    }
}

LessonInfoVideo.propTypes = {
    videoList: PropTypes.array,
    isSaveProcessing: PropTypes.bool,
    disabled: PropTypes.bool,
    isEditable: PropTypes.bool,
    onSave: PropTypes.func,
    onRecordOpen: PropTypes.func,
    openVideoPreview: PropTypes.func,
    onRemove: PropTypes.func,
    onVideoLinkOpen: PropTypes.func
};

export default LessonInfoVideo;
